import React, { useState, useEffect } from 'react';
import {MenuItemLink, usePermissions, useQueryWithStore, UserMenu} from 'react-admin'
import SettingsIcon from '@material-ui/icons/Settings'
import ListIcon from '@material-ui/icons/ListAltOutlined'
import { useDispatch, useSelector } from 'react-redux';
import { FormControlLabel, Switch } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';

const MyUserMenu = props => {

    const { loaded, error, data: profile} = useQueryWithStore({
        type: 'getMany',
        resource: 'users/me',
        payload: {filter:{},pagination:{},sort:{}}
    });

    const p= usePermissions()
    const permissions = p.permissions

    const dispatch = useDispatch();
    const isAvailable = useSelector(state => state.user.currentUser && state.user.currentUser.isAvailable !== undefined ? state.user.currentUser.isAvailable : true);
    const [availability, setAvailability] = useState(isAvailable);

    useEffect(() => {
        setAvailability(isAvailable);
    }, [isAvailable]);

    const handleAvailabilityToggle = async (event) => {
        const newValue = event.target.checked;
        try {
            const response = await fetch(`${localStorage.getItem('domain')}/api/users/me/availability`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                    'X-COMPANY': localStorage.getItem('company') || 'ROOT',
                    'Bypass-Tunnel-Reminder': 'true'
                },
                body: JSON.stringify({isAvailable: newValue})
            });
            if (response.ok) {
                setAvailability(newValue);
                dispatch({ type: 'USER_AVAILABILITY_UPDATED', payload: { isAvailable: newValue } });
            } else {
                // Optionally handle error
            }
        } catch (error) {
            // Optionally handle error
        }
    };

    return (
        <UserMenu label={profile ? profile.username : ''} {...props}>
            <MenuItemLink
                to="/my-profile"
                primaryText="Edit Profile"
                leftIcon={<SettingsIcon />}
            />
            <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
               Your Roles:  {permissions&&permissions.map(p=><Chip label={p} key={p}/>)}
            </div>
            <FormControlLabel
                control={
                    <Switch
                        checked={!!availability}
                        onChange={handleAvailabilityToggle}
                        color="primary"
                    />
                }
                label={availability ? 'Available' : 'Not Available'}
            />
            {permissions && !permissions.includes('Superuser') && <MenuItemLink
                to={{ pathname: '/selectCompanies', flush:true }}
                primaryText="Select Another Company"
                leftIcon={<ListIcon/>}
            />
            }

        </UserMenu>
    );
};

export default MyUserMenu;
